// Phân loại khối nội dung — dùng chung cho LỒNG TIẾNG (mức khối) và TÍNH TIẾN ĐỘ hoàn thành.
// Giữ một nguồn sự thật để builder, viewer và InteractiveContentRenderer đếm/lọc nhất quán.

// Câu hỏi tương tác — KHÔNG lồng tiếng, tính là "mục câu hỏi" cho tiến độ.
export const QUESTION_TYPES = new Set([
  'interactive_question', 'multiple_response_question', 'sequence_question',
])

// Khối văn xuôi ĐỌC ĐƯỢC để lồng tiếng (KHÔNG gồm tiêu đề/câu hỏi/mô phỏng/ảnh).
const AUDIOABLE = new Set(['text', 'concept_card', 'example', 'warning', 'conclusion_card'])

// Khối text tính là 1 "mục đọc" cho tiến độ (rộng hơn audioable: gồm cả công thức/danh sách/bảng).
const VIEWABLE_TEXT = new Set([
  'text', 'concept_card', 'example', 'warning', 'conclusion_card', 'formula', 'list', 'table',
])

export function isQuestionBlock(item: any): boolean {
  return !!item && QUESTION_TYPES.has(item.type)
}

export function isAudioableBlock(item: any): boolean {
  return !!item && AUDIOABLE.has(item.type) && typeof item.content === 'string' && item.content.trim().length > 0
}

export function isViewableTextBlock(item: any): boolean {
  return !!item && VIEWABLE_TEXT.has(item.type)
}

// Giọng đọc khả dụng khi tạo audio. Mặc định dùng Gemini TTS (giọng tự nhiên hơn);
// nếu server thiếu key Gemini sẽ tự quay về OpenAI tts-1 với giọng tương ứng (backend tự ánh xạ).
export const TTS_VOICES: { id: string; label: string }[] = [
  { id: 'Kore', label: 'Kore (vững vàng) — mặc định' },
  { id: 'Sulafat', label: 'Sulafat (ấm áp)' },
  { id: 'Aoede', label: 'Aoede (nhẹ nhàng)' },
  { id: 'Leda', label: 'Leda (trẻ trung)' },
  { id: 'Zephyr', label: 'Zephyr (tươi sáng)' },
  { id: 'Charon', label: 'Charon (rõ ràng, hợp giảng bài)' },
  { id: 'Puck', label: 'Puck (vui tươi)' },
  { id: 'Orus', label: 'Orus (chắc, trầm)' },
  { id: 'Enceladus', label: 'Enceladus (nhẹ, thủ thỉ)' },
]
